import { t } from "i18next";

import { MAX_FEEDBACK_INPUT_IMAGE_SIZE } from "@/src/config/baanaConfig";
import { UserDTO } from "@/src/types/types";

export const getErrorMessage = (status: number): string => {
  switch (status) {
    case 400:
      return t("feedbackForm.error.badRequest");
    case 401:
      return t("feedbackForm.error.unauthorized");
    case 403:
      return t("feedbackForm.error.forbidden");
    case 422:
      return t("feedbackForm.error.unprocessable");
    case 429:
      return t("feedbackForm.error.rateLimit");
    default:
      return t("feedbackForm.error.generic");
  }
};

export const validateFileSize = (file: File): boolean =>
  file.size <= MAX_FEEDBACK_INPUT_IMAGE_SIZE;

export const buildFeedbackDefaultValues = (
  user: UserDTO | null | undefined
) => {
  let name = "";
  if (user?.firstName && user?.lastName) {
    name = `${user.firstName} ${user.lastName}`;
  }

  return {
    email: user?.email ?? "",
    name,
    mobile: user?.phoneNumber ?? "",
    issueType: "",
    message: ""
  };
};
